import { apiClient } from '@/services/api';
import type {
  CashOutListResponse,
  CashOutResponse,
  RedemptionLinkResponse,
} from '@/types/cashout';

export const cashoutsService = {
  async create(
    amountCents: number,
    idempotencyKey: string,
  ): Promise<CashOutResponse> {
    return apiClient.post<CashOutResponse>(
      '/api/v1/cash_outs',
      { amount_cents: amountCents },
      { idempotencyKey },
    );
  },

  async show(id: number): Promise<CashOutResponse> {
    return apiClient.get<CashOutResponse>(`/api/v1/cash_outs/${id}`);
  },

  async list(): Promise<CashOutListResponse> {
    return apiClient.get<CashOutListResponse>('/api/v1/cash_outs');
  },

  async getLink(id: number): Promise<RedemptionLinkResponse> {
    return apiClient.post<RedemptionLinkResponse>(
      `/api/v1/cash_outs/${id}/link`,
    );
  },
};
